import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators'

import ImplicitAuthProvider from '../../ImplicitAuthProvider'
import AuthStoreModuleContainer from './AuthStoreModuleContainer'

@Module({
  name: 'auth',
  namespaced: true,
  stateFactory: true
})
export default class AuthStoreModule extends VuexModule {
  provider: ImplicitAuthProvider | null = null

  @Mutation
  inject (container: AuthStoreModuleContainer) {
    this.provider = container.implicitAuthProvider
  }

  @Action
  public async asyncLogout (): Promise<void> {
    if (this.provider === null) {
      throw new Error()
    }
    await this.provider.asyncLogout()
  }
}
